<template>
    <div class=" container-fluid bg-white rounded-2 pt-4 ">
        <h2 class="text-center">IOP Medical Print File</h2>
        <hr />

        <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

        <div v-else>

            <!-- Section 1: Student Info -->
            <section class="mb-4">
                <h5>Student Info</h5>
                <hr />
                <div><strong>Name:</strong> {{ student?.user?.name || '-' }}</div>
                <!-- <div><strong>Email:</strong> {{ student?.user?.email || '-' }}</div> -->
                <div><strong>PID:</strong> {{ student?.pid || '-' }}</div>
                <!-- <div><strong>Course:</strong> {{ data.student?.course || '-' }}</div> -->
            </section>

            <section class="mb-4">
                <h5>Medical Demographics</h5>
                <hr />
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th style="width:30%">Gender</th>
                            <td>{{ medicalPrint.demographic?.gender || '-' }}</td>
                        </tr>
                        <tr>
                            <th>DOB</th>
                            <td>{{ $formatDate(medicalPrint.demographic?.dob) || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Age</th>
                            <td>{{ medicalPrint.demographic?.age || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Eye Color</th>
                            <td>{{ medicalPrint.demographic?.eye_color || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Weight</th>
                            <td>{{ medicalPrint.demographic?.weight || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Height</th>
                            <td>{{ medicalPrint.demographic?.height || '-' }}</td>
                        </tr>
                        <tr>
                            <th>BMI</th>
                            <td>{{ medicalPrint.demographic?.bmi || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Marital Status</th>
                            <td>{{ medicalPrint.demographic?.marital_status || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Street Address</th>
                            <td>{{ medicalPrint.demographic?.street_address || '-' }}</td>
                        </tr>
                        <tr>
                            <th>City</th>
                            <td>{{ medicalPrint.demographic?.city || '-' }}</td>
                        </tr>
                        <tr>
                            <th>State</th>
                            <td>{{ medicalPrint.demographic?.state || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Zip</th>
                            <td>{{ medicalPrint.demographic?.zip || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Phone</th>
                            <td>{{ medicalPrint.demographic?.phone || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-sm btn-primary"
                    @click="$router.push({ name: 'IopMedicalDemographicForm', params: { iop_medical_print_id: medicalPrint.id } })">
                    ✏️ Update
                </button>
            </section>

            <!-- Section 3: Medical History -->
            <section class="mb-4">
                <h5>Medical History</h5>
                <hr />
                <table class="table table-bordered table-striped">
                    <tbody>

                        <tr>
                            <th style="width:30%">Alcohol Abuse</th>
                            <td>{{ medicalPrint.history?.alcohol_abuse ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Alcohol Comment</th>
                            <td>{{ medicalPrint.history?.alcohol_comment || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Tobacco Use</th>
                            <td>{{ medicalPrint.history?.tobacco_use ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Tobacco Comment</th>
                            <td>{{ medicalPrint.history?.tobacco_comment || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Withdrawal Symptoms</th>
                            <td>{{ medicalPrint.history?.withdrawal_symptoms || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Allergies</th>
                            <td>{{ medicalPrint.history?.allergies || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Current Treatment</th>
                            <td>{{ medicalPrint.history?.current_treatment ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Treatment Details</th>
                            <td>{{ medicalPrint.history?.treatment_details || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Hospitalization</th>
                            <td>{{ medicalPrint.history?.hospitalization ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Hospitalization Details</th>
                            <td>{{ medicalPrint.history?.hospitalization_details || '-' }}</td>
                        </tr>
                        <tr>
                            <th>ER Visit</th>
                            <td>{{ medicalPrint.history?.er_visit ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>ER Visit Details</th>
                            <td>{{ medicalPrint.history?.er_visit_details || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-sm btn-primary"
                    @click="$router.push({ name: 'IopMedicalHistoryForm', params: { iop_medical_print_id: medicalPrint.id } })">
                    ✏️ Update
                </button>
            </section>

            <!-- Section 4: Medical Tests -->
            <section class="mb-4">
                <h5>Medical Tests</h5>
                <hr />
                <table class="table table-bordered table-striped">
                    <tbody>
                        <tr>
                            <th style="width:30%">Dental Exam Date</th>
                            <td>{{ $formatDate(medicalPrint.test?.dental_exam_date) || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Dental Exam Location</th>
                            <td>{{ medicalPrint.test?.dental_exam_location || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Chest X-ray Date</th>
                            <td>{{ $formatDate(medicalPrint.test?.chest_xray_date) || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Chest X-ray Location</th>
                            <td>{{ medicalPrint.test?.chest_xray_location || '-' }}</td>
                        </tr>
                        <tr>
                            <th>HIV Test</th>
                            <td>{{ medicalPrint.test?.hiv_test ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>HIV Result</th>
                            <td>{{ medicalPrint.test?.hiv_result || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Hep B Test</th>
                            <td>{{ medicalPrint.test?.hep_b_test ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Hep B Result</th>
                            <td>{{ medicalPrint.test?.hep_b_result || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Hep C Test</th>
                            <td>{{ medicalPrint.test?.hep_c_test ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Hep C Result</th>
                            <td>{{ medicalPrint.test?.hep_c_result || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Overdose</th>
                            <td>{{ medicalPrint.test?.overdose ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Overdose Count</th>
                            <td>{{ medicalPrint.test?.overdose_count || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Overdose When</th>
                            <td>{{ medicalPrint.test?.overdose_when || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Opioid Treatment</th>
                            <td>{{ medicalPrint.test?.opioid_treatment ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Opioid Facility</th>
                            <td>{{ medicalPrint.test?.opioid_facility || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Opioid Date</th>
                            <td>{{ medicalPrint.test?.opioid_date || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Opioid Dose</th>
                            <td>{{ medicalPrint.test?.opioid_dose || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Opioid Takehome</th>
                            <td>{{ medicalPrint.test?.opioid_takehome || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Opioid Reason</th>
                            <td>{{ medicalPrint.test?.opioid_reason || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-sm btn-primary"
                    @click="$router.push({ name: 'IOPMedicalTest', params: { iop_medical_print_id: medicalPrint.id } })">
                    ✏️ Update
                </button>
            </section>

            <!-- Section 5: Obstetrical History -->
            <div class="section mt-4 mb-4">
                <h4>Obstetrical History</h4>
                <hr />
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th>Pregnant</th>
                            <td>{{ medicalPrint.obstetrical_history?.pregnant ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Ever Pregnant</th>
                            <td>{{ medicalPrint.obstetrical_history?.ever_pregnant ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Pregnancy Count</th>
                            <td>{{ medicalPrint.obstetrical_history?.pregnancy_count || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Contraceptive Type</th>
                            <td>{{ medicalPrint.obstetrical_history?.contraceptive_type || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Regular Cycle</th>
                            <td>{{ medicalPrint.obstetrical_history?.regular_cycle ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Cramping</th>
                            <td>{{ medicalPrint.obstetrical_history?.cramping ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Comments</th>
                            <td>{{ medicalPrint.obstetrical_history?.comments || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Pap Smear</th>
                            <td>{{ medicalPrint.obstetrical_history?.pap_smear ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Pap Smear When</th>
                            <td>{{ medicalPrint.obstetrical_history?.pap_smear_when || '-' }}</td>
                        </tr>
                    </tbody>
                </table>

                <button class="btn btn-sm btn-primary mt-2"
                    @click="$router.push({ name: 'IOPObstetricalHistoryForm', params: { iop_medical_print_id: medicalPrint.id } })">
                    {{ medicalPrint.obstetrical_history ? 'Update' : 'Update' }} Obstetrical History
                </button>
            </div>

            <!-- Section 6: Vitals -->
            <section class="mb-4">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Vitals</h5>

                </div>
                <hr />
                <table class="table table-bordered table-striped">
                    <tbody>
                        <tr>
                            <th style="width:30%">Pulse</th>
                            <td>{{ medicalPrint.vital?.pulse || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Respiration</th>
                            <td>{{ medicalPrint.vital?.respiration || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Temperature</th>
                            <td>{{ medicalPrint.vital?.temperature || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Blood Pressure</th>
                            <td>{{ medicalPrint.vital?.blood_pressure || '-' }}</td>
                        </tr>
                        <tr>
                            <th>Oxygen</th>
                            <td>{{ medicalPrint.vital?.oxygen || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-sm btn-primary"
                    @click="$router.push({ name: 'IOPMedicalVitals', params: { iop_medical_print_id: medicalPrint.id } })">
                    ✏️ Update
                </button>
            </section>

            <!-- Section 7: Psychiatric Evaluation -->
            <section class="mb-4">
                <h5>Psychiatric Evaluation</h5>
                <hr />
                <div><strong>Diagnosis:</strong> {{ medicalPrint.psychiatric?.diagnosis || '-' }}</div>
                <div><strong>Treatment Plan:</strong> {{ medicalPrint.psychiatric?.treatment_plan || '-' }}</div>
            </section>

            <!-- Section 8: Physical Exam -->
            <section class="mb-4">
                <h5>Physical Exam</h5>
                <hr />
                <div><strong>Findings:</strong> {{ medicalPrint.physical?.findings || '-' }}</div>
                <div><strong>Recommendations:</strong> {{ medicalPrint.physical?.recommendations || '-' }}</div>
            </section>

            <!-- Section 9: TB Questionnaire -->
            <section class="mb-4">
                <h5>TB Questionnaire</h5>
                <hr />
                <div><strong>Exposure History:</strong> {{ medicalPrint.tb?.exposure_history || '-' }}</div>
                <div><strong>Symptoms:</strong> {{ medicalPrint.tb?.symptoms || '-' }}</div>
            </section>

            <!-- Section 10: Medication Summary -->
            <section class="mb-4">
                <h5>Medication Summary</h5>
                <hr />
                <div><strong>Medication Name:</strong> {{ medicalPrint.medication?.name || '-' }}</div>
                <div><strong>Symptoms Treated:</strong> {{ medicalPrint.medication?.symptoms || '-' }}</div>
                <div><strong>Frequency/Dosage:</strong> {{ medicalPrint.medication?.dosage || '-' }}</div>
            </section>

        </div>
    </div>
</template>
<script>
export default {
    name: 'IOPmedicalPrintDetail',
    data() {
        return {
            student: {},
            medicalPrint: {},
            loading: true,
            error: '',
        };
    },
    mounted() {
        this.fetchStudent();
    },
    methods: {
        async fetchStudent() {
            const res = await this.$api.get(`/students/${this.$route.params.student_id}`);
            console.log(res.data);
            if (res.data && Object.keys(res.data).length > 0) {
                this.student = res.data;
                await this.fetchMedicalPrint();
            } else {
                this.error = 'Student not found';

            }
            this.loading = false;
        },

        async fetchMedicalPrint() {
            const res = await this.$api.get(`/iop-medical-prints/${this.student.id}`);
            if (res.data && Object.keys(res.data).length > 0) {
                this.medicalPrint = res.data;
                // this.student.iop_medical_print_id = this.medicalPrint.id;
            } else {
                await this.createMedicalPrint();
            }
            this.loading = false;
        },

        async createMedicalPrint() {
            const res = await this.$api.post(`/iop-medical-prints`, {
                student_id: this.student.id,
                date: new Date().toISOString().slice(0, 10),
            });
            if (res.data && Object.keys(res.data).length > 0) {
                this.medicalPrint = res.data;
                this.fetchMedicalPrint();
                // this.student.iop_medical_print_id = this.medicalPrint.id;
            } else {
                this.error = 'Failed to create Medical Print';
            }
            this.loading = false;
        }
    }
}
</script>
